import { ReactNode } from "react";
import { FaTimes } from "react-icons/fa";
import { useScrollLock } from "../../../Hooks/useScrollLock";

type ModalProps = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  isDismissable?: boolean;
  maxWidth?: string;
};

const Modal = ({ isOpen, onClose, title, children, isDismissable = true, maxWidth = "max-w-lg" }: ModalProps) => {
  useScrollLock(isOpen);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 px-4">
      <div className={`bg-white rounded-lg shadow-lg w-full ${maxWidth} p-6 relative max-h-[90vh] overflow-y-auto`}>
        <button
          onClick={onClose}
          className={`absolute top-4 right-4 text-2xl font-bold ${
            isDismissable
              ? "text-primary-600 hover:text-primary-700"
              : "text-gray-300 cursor-not-allowed"
          }`}
          aria-label="Fechar"
          disabled={!isDismissable}
        >
          <FaTimes />
        </button>

        {title && (
          <h2 className="text-lg font-semibold mb-4 text-center">{title}</h2>
        )}

        <div>{children}</div>
      </div>
    </div>
  );
};

export default Modal;
